import axios from 'axios'

const API_URL = process.env.REACT_APP_CLIENTS_API_URL

export const twoFactorService = {
  // Get 2FA settings
  getTwoFactorSettings: async (userId, token) => {
    try {
      const response = await axios.get(`${API_URL}/account/${userId}/two_factor_settings`, {
        headers: { Authorization: token }
      })
      return { success: true, data: response?.data }
    } catch (error) {
      console.error('[2FA] Error getting two factor settings', error)
      return {
        success: false,
        error: error.response?.data || error?.message
      }
    }
  },

  // Request 2FA code
  request2FA: async (contact) => {
    try {
      const response = await axios.post(`${API_URL}/otp/request`, {
        input: contact,
        project: 'bravo'
      })
      return { success: true, data: response?.data }
    } catch (error) {
      console.error('[2FA] Error requesting OTP', error)
      return {
        success: false,
        error: error.response?.data || error?.message
      }
    }
  },

  // Validate 2FA code
  validate2FA: async (contact, code, uid) => {
    try {
      const response = await axios.post(`${API_URL}/otp/validate`, {
        data: {
          input: contact,
          code: code,
          uid: uid
        }
      })
      return { success: true, data: response?.data }
    } catch (error) {
      console.error('[2FA] Error validating OTP', error)
      return {
        success: false,
        error: {
          ...error.response?.data,
          message: error.response?.data?.message || error?.message,
          attempts: error.response?.data?.attempt || 0,
          attempt: error.response?.data?.attempt || 0,
          status: error.response?.data?.status || 'error',
          expired: error.response?.data?.expired || false,
          expires_at: error.response?.data?.expires_at,
          receiver: error.response?.data?.receiver,
          uid: error.response?.data?.uid
        }
      }
    }
  },

  // Enable/disable 2FA
  toggleTwoFactor: async (userId, enabled, token) => {
    try {
      const response = await axios.put(
        `${API_URL}/account/${userId}/set_two_factor`,
        { enabled },
        { headers: { Authorization: token } }
      )
      return { success: true, data: response?.data }
    } catch (error) {
      console.error('[2FA] Error toggling two factor', error)
      return {
        success: false,
        error: error.response?.data || error?.message
      }
    }
  }
}

export default twoFactorService
